import { zod } from '@acme/core'
import _filter from 'lodash.filter'
import { queryClient } from 'providers/ReactQuery'
import { z } from 'zod'
import ApiService from '../api.service'

type QueryParams = {
    empresaId: number
}

export interface Afd {
    empresaId: number
    file?: File
    dataInicial: string
    dataFinal: string
}

export type HistoricoImportacao = z.infer<typeof zod.HistoricoImportacaoSchema>

const service = new ApiService<Afd, HistoricoImportacao, QueryParams>('afd')

export const afd = Object.assign(service, {
    fillHistoricos: (historico: HistoricoImportacao) => {
        const queryKey = service.queryKey({ empresaId: historico.empresaId })

        queryClient.setQueryData<HistoricoImportacao[]>(
            queryKey,
            historicos => {
                if (!historicos) return [historico]

                const index = historicos.findIndex(h => h.id === historico.id)
                if (index === -1) return [...historicos, historico]

                const filteredHistoricos = _filter(
                    historicos,
                    h => h.id !== historico.id,
                )

                return [...filteredHistoricos, historico]
            },
        )
    },
})
